<div *cdkPortal class="wrapper" [ngStyle]="{ 'z-index': layer + 1 }" [ngClass]="align">
  <div
    class="panel"
    [style.width]="width"
    [@panelState]="state"
    (@panelState.start)="closing = $event.fromState?.slice(0, 6) === 'opened'"
    (@panelState.done)="closing = false"
  >
    <div class="body z-fx-col" [class.closed]="!isOpen()" [class.has-open-childs]="hasOpenChilds()">
      @if (isOpen() && template) {
        <ng-container [ngTemplateOutlet]="template"></ng-container>
      }

      @if (!template) {
        <ng-content></ng-content>
      }
    </div>
  </div>
</div>
